import {rYAxisLines} from "./y-axis-lines";
import {cFieldGroupAxes} from "../../../common/field-group-axes";

export const YAxesLines = (yAxisLine) => (yAxisLine ? Object.keys(yAxisLine).map((k) => rYAxisLines(k)) : []);
